import { render } from "./LayoutHeader.vue?vue&type=template&id=72a487bb&scoped=true"
import script from "./LayoutHeader.vue?vue&type=script&lang=js"
export * from "./LayoutHeader.vue?vue&type=script&lang=js"

import "./LayoutHeader.vue?vue&type=style&index=0&id=72a487bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a487bb"]])

export default __exports__